import React from 'react'
import './NotFound.css';
const NotFound = () => {
  return (
    <div className='notFound'>
      <p >Not Found</p>
    </div>
  );
}

export default NotFound
